export default "__VITE_PUBLIC_ASSET__577a48d1__"